// noinspection JSNonASCIINames,NonAsciiCharacters

export const companySettingsTranslations = {
    company_settings: {
        tabs: {
            "General company data": {
                name: "Ettevõtte üldinfo",
                tip: "Nimi, logotüüp jn"
            },
            "Company registration data": {
                name: "Ettevõtte registreerimisandmed",
                tip: "Registrikood, aadress.."
            },
            "Invoice details": {
                name: "Arve andmed",
                tip: "Müügiarvete andmed"
            }
        },
        general: {
            name: "Firma nimi",
            name_error: "Palun sisestage ettevõtte nimi",
            logo: "Logotüüp",
            no_logo: "Logotüüp puudub"
        },
        reg_data: {
            reg_code: "Registrikood",
            reg_code_error: "Palun sisestage registrikood",
            vat_number: "EMTAK kood",
            legal_address: "Juriidiline aadress",
            city: "Linn",
            post_code: "Sihtnumber",
            country: "Riik",
            country_error: "Palun täpsustage registreerimisriiki",
            email: "Elektronposti aadress",
            email_error: "E-posti formaat on vigane",
            phone_num: "Telefon",
        },
        invoice: {
            header_address: "Aadress",
            use_legal_address: "Kasutage juriidilist aadressi",
            invoice_address: "Arve aadress",
            city: "Linn",
            post_code: "Sihtnumber",
            country: "Riik",
            country_error: "Palun täpsustage arve riiki",
            email: "E-post",
            email_error: "E-posti formaat on vigane",
            phone_num: "Telefon",


            header_banks: "Pangad",
            account_error: "Palun valige konto number",
            bank_detail: "Pangaandmed",
            bank_detail_error: "Palun sisestage pangaandmed",
            additional_bank_detail: "Panga lisaandmed",
        }
    }
}